'use strict';

require('./build/buildDateRangeUnitsCall');

// This package does not export anything as it is
// simply defining "months" on Range.prototype.


// WEBPACK FOOTER //
// ./~/sugar-date/range/months.js